import { useClientLogger } from '@landsbankinn/client-logger';
import { useResource } from '@landsbankinn/l16n';
import {
  ArrowIcon24,
  Box,
  H2,
  ListItem,
  RichLink,
  ShortSplitter,
  UnorderedList,
  useUUID,
} from '@landsbankinn/ui-kit';
import { useRef, useState } from 'react';
import { useScreenSize } from 'src/hooks/useScreenSize';
import type { User } from 'src/state/server';
import {
  type SelectAccountServerState,
  useApplicationServerContext,
} from '../../state';
import { Layout } from '../Layout';
import { Loading } from '../Loading';
import { submit } from '../Login/utils';
import { res } from './SelectAccount.res';

export function SelectAccount() {
  const [state] = useApplicationServerContext();
  const { logger } = useClientLogger();
  const serverState: SelectAccountServerState =
    state as SelectAccountServerState;
  const { isXL } = useScreenSize();
  const [selectedUsername, setSelectedUsername] = useState<string | null>();
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);
  const { r } = useResource();

  const headingId = useUUID();

  function submitForm(selectedUser: User) {
    if (!selectedUsername && formRef.current) {
      setSelectedUsername(selectedUser.userName);
      setIsLoading(true);
      logger.message('Account selected', {
        userName: selectedUser.userName,
      });
      if (formRef.current) submit(formRef.current);
    }
  }

  return (
    <Layout>
      <Box
        hidden={isLoading}
        color="blue font"
        // maxWidth="480"
        minHeight="480"
        grow="1"
      >
        <H2 id={headingId} fontVariant={isXL ? 'h2' : 'h3'}>
          {r(res.selectUser)}
        </H2>

        <ShortSplitter />

        <UnorderedList animated={false} aria-labelledby={headingId}>
          {serverState.users.map((selectedUser: User) => (
            <ListItem key={selectedUser.userName}>
              <RichLink
                aria-label={`${r(res.selectUser)} ${selectedUser.userName}`}
                condense
                instrumentAs="rich_button"
                label={selectedUser.name}
                labelFontSize="18"
                endIcon={<ArrowIcon24 />}
                sublabel={selectedUser.userName}
                onClick={() => submitForm(selectedUser)}
              />
            </ListItem>
          ))}
        </UnorderedList>

        <form ref={formRef} action={serverState.form.action} method="post">
          <input
            type="hidden"
            name={serverState.form.fields.traceparent.name}
            value={serverState.form.fields.traceparent.value}
          />
          <input
            type="hidden"
            name={serverState.form.fields.xsrf.name}
            value={serverState.form.fields.xsrf.value}
          />
          <input
            type="hidden"
            name={serverState.form.fields.userName.name}
            value={selectedUsername || ''}
          />
        </form>
      </Box>
      {isLoading && (
        <Loading
          title={r(res.loadingTitle)}
          description={r(res.loadingDescription)}
        />
      )}
    </Layout>
  );
}
